export const VARIANT = {
    Middle: 'middle',
    End: 'end',
};
